import {createSelector, createSlice} from '@reduxjs/toolkit'
import {RootState} from './store'
import {AllSessions, Session} from 'src/app/types'
import {appApi} from './appApiQueries'
import {initialState as initialSessionState} from './session'

type AllSessionData = {
    allSessions: AllSessions
    // making this property optional to allow it be undefined. So that it helps component to show spinner when undefined.
    allSortedSessions: Session[] // most recent first
}

const initialState: AllSessionData = {
    allSessions: {},
    allSortedSessions: [],
}

const allSessionsSlice = createSlice({
    name: 'allSessionsData',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        // TODO: if we'd like the getting of all sessions to be more performant, we will need to add matchers here that edit the state just like the endpoints do for every single endpoint
        // alternatively we can add manual optimistic cache updates per rtk: https://redux-toolkit.js.org/rtk-query/usage/manual-cache-updates
        // fill initial state
        builder.addMatcher(
            appApi.endpoints.getAllSessions.matchFulfilled,
            (state, {payload}) => {
                const allSessions = payload || []
                state.allSessions = allSessions
                state.allSortedSessions = Object.values(allSessions).sort((a, b) => {
                    if (a.dateCreated && b.dateCreated) {
                        return b.dateCreated - a.dateCreated
                    } else if (!a.dateCreated && !b.dateCreated) {
                        return 0
                    } else if (!a.dateCreated) {
                        return 1
                    } else {
                        return -1
                    }
                })
            }
        )
    },
})

export const selectAllSessions = (state: RootState) =>
    state.allSessionsData.allSessions
export const selectAllSortedSessions = (state: RootState) =>
    state.allSessionsData.allSortedSessions
export const sessionNames = createSelector(
    selectAllSortedSessions,
    (sessions): string[] => {
        const uniqueNames = new Set<string>();
        sessions.forEach(session => {
            uniqueNames.add(session.name!)
        });
        return Array.from(uniqueNames);
    }
)
export const selectStoredSession = createSelector(
    selectAllSessions,
    (_state: RootState, props: { groupId: string; id: string }) => props,
    (allSessions, {id}) => {
        let session = initialSessionState
        if (allSessions?.[id]) session = allSessions[id]
        return session
    }
)

export default allSessionsSlice
